import router from '@/routers/router'
import api from '@/services/api';

import { select2_reset } from '@/services/select';
import { APP, DIR, DIR_API } from '@/services/localhost';


    // NEW

        // HTML_TABLE
            export function HTML_TABLE(item, value, col)
            {
                let $return = item.split('-->HTML->')[1];
                $return = replace('script', '', $return);
                return $return ? $return : ``;
            }
        // HTML_TABLE

    // NEW






    // TREATMENT ARRAY
        // OBJ_FORMDATA
            export function obj_formData(obj, form = null, namespace = null)
            {
                var fd = form || new FormData();
                var formKey;
            
                for (var property in obj) {
                    if (obj.hasOwnProperty(property)) {
                        if (namespace) {
                            formKey = namespace + "[" + property + "]";
                        } else {
                            formKey = property;
                        }
            
                        if (typeof obj[property] === "object") {
                            if (Array.isArray(obj[property])) {
                                for (var i = 0; i < obj[property].length; i++) {
                                    obj_formData(obj[property][i], fd, formKey + "[" + i + "]");
                                }
                            } else {
                                obj_formData(obj[property], fd, formKey);
                            }
                        } else {
                            fd.append(formKey, obj[property]);
                        }
                    }
                }
            
                return fd;
            }
        // OBJ_FORMDATA
    // TREATMENT ARRAY







    // NUMBERS
        // PRICE
            export function price($value)
            {
                const options = {
                    style: 'currency',
                    currency: 'BRL'
                }
                let $return = new Intl.NumberFormat('pt-br', options).format($value)

                return $return;
            }
        // PRICE

        // PRICE_
            export function price_($value)
            {
                $value = replace(' ', '', $value);
                $value = replace('R$', '', $value);
                $value = replace(',', '', $value);
                $value = replace('.', '', $value);
                $value = parseInt($value);
                $value = parseInt($value);
                $value = $value/100;
                return $value;
            }
        // PRICE_

        // RAND
            export function rand(min=100000, max=999999)
            {
                let $return = Math.floor(Math.random() * (max - min + 1) + min);
                return $return;
            }
            export function rand_str()
            {
                let $return = (Math.random() + 1).toString(36).substring(7);
                return $return;
            }
        // RAND
    // NUMBERS







    // DATE
        // DATE
            export function data($data, $format='d/m/Y', $tipo='-')
            {
                if(!compare__($tipo, $data)){
                    return $data;
                }
                
                if(!$data || $data == null || $data == '0000-00-00' || $data == '0000-00-00 00:00:00'){
                    return '';
                }

                $data = replace('T', $tipo, $data);
                $data = replace('BRT', $tipo, $data);
                $data = divide_data($data, $tipo);
                return $data[2]!=undefined ? date($format, `${$data[0]}-${$data[1]}-${$data[2]} ${$data[3]}:${$data[4]}:${$data[5]}`) : 'erro';
            }
        // DATE

        // DATE
            function date(format, data)
            {
                var date = new Date(data);
    
                var year = date.getFullYear();
                var month = ('0' + (date.getMonth() + 1)).slice(-2);
                var day = ('0' + date.getDate()).slice(-2);
                var hours = ('0' + date.getHours()).slice(-2);
                var minutes = ('0' + date.getMinutes()).slice(-2);
                var seconds = ('0' + date.getSeconds()).slice(-2);
            
                return format
                    .replace('Y', year)
                    .replace('m', month)
                    .replace('d', day)
                    .replace('H', hours)
                    .replace('i', minutes)
                    .replace('s', seconds);
            }
        // DATE

        // DIVIDE_DATA
            export function divide_data($data, $tipo='-')
            {
                $data = replace(' ', $tipo, $data);
                $data = replace(':', $tipo, $data);
                $data = replace('T', '-', $data);
                $data = replace('BRT', '-', $data);
                $data = replace('.', '-', $data);
                $data = $data.split($tipo);
                $data[3] = $data[3]!=undefined ? $data[3] : 0;
                $data[4] = $data[4]!=undefined ? $data[4] : 0;
                $data[5] = $data[5]!=undefined ? $data[5] : 0;
                return  $data;
            }
        // DIVIDE_DATA

        // HOJE / NOW
            export function hoje()
            {
                let date = new Date();
                return`${date.getFullYear()}-${(`00`+(date.getMonth()+1)).slice(-2)}-${(`00`+date.getDate()).slice(-2)}`;
            }
            export function now()
            {
                let date = new Date();
                return `${date.getFullYear()}-${(`00`+(date.getMonth()+1)).slice(-2)}-${(`00`+date.getDate()).slice(-2)} ${(`00`+date.getHours()).slice(-2)}:${(`00`+date.getMinutes()).slice(-2)}:${(`00`+date.getSeconds()).slice(-2)}`;
            }
        // HOJE / NOW

        // BIRTH
            export function birth()
            {
                let TODAY = new Date()
                let TODAY_15 = new Date(TODAY.getFullYear(), TODAY.getMonth()-(18*12)+1, TODAY.getDate());
                return`${TODAY_15.getFullYear()}-${(`00`+(TODAY_15.getMonth()+1)).slice(-2)}-${(`00`+TODAY_15.getDate()).slice(-2)}`;
            }
        // BIRTH

        // DIA DA SEMANA
            export function dia_semana(data, tipo='-')
            {
                const dataParts = data.split(tipo);
                const dia = parseInt(dataParts[2]);
                const mes = parseInt(dataParts[1]);
                const ano = parseInt(dataParts[0]);
                const diasemana = new Date(ano, mes - 1, dia).getDay();

                let returnDia;
                switch(diasemana) {
                    case 0: returnDia = "Domingo"; break;
                    case 1: returnDia = "Segunda"; break;
                    case 2: returnDia = "Terça"; break;
                    case 3: returnDia = "Quarta"; break;
                    case 4: returnDia = "Quinta"; break;
                    case 5: returnDia = "Sexta"; break;
                    case 6: returnDia = "Sábado"; break;
                }
                return returnDia;
            }
        // DIA DA SEMANA

        // MÊS ABREVIAÇÃO
            export function mes(mes, ab=0)
            {
                let returnMes;
                switch(mes) {
                    case 1: returnMes = ab ? 'Jan'  : 'Janeiro'; break;
                    case 2: returnMes = ab ? 'Fev'  : 'Fevereiro'; break;
                    case 3: returnMes = ab ? 'Mar'  : 'Março'; break;
                    case 4: returnMes = ab ? 'Abr'  : 'Abril'; break;
                    case 5: returnMes = ab ? 'Mai'  : 'Maio'; break;
                    case 6: returnMes = ab ? 'Jun'  : 'Junho'; break;
                    case 7: returnMes = ab ? 'Jul'  : 'Julho'; break;
                    case 8: returnMes = ab ? 'Ago'  : 'Agosto'; break;
                    case 9: returnMes = ab ? 'Set'  : 'Setembro'; break;
                    case 10: returnMes = ab ? 'Out' : 'Outubro'; break;
                    case 11: returnMes = ab ? 'Nov' : 'Novembro'; break;
                    case 12: returnMes = ab ? 'Dez' : 'Dezembro'; break;
                }
                return returnMes;
            }
        // MÊS ABREVIAÇÃO

    // DATE







    // USEFUL
        // SPLIT | COMPARE__
            export function split_1(match, value)
            {
                try {
                    if(value && value.split(match)[1] != null){
                        return true;
                    }
                } catch (error) { }
                return false;
            }

            export function explode(match, value)
            {
                return value.split(match);
            }

            export function compare__(match, value)
            {
                return split_1(match, value);
            }
            export function compare__ini(match, value)
            {
                return value.includes(match);
            }
            export function compare__fim(match, value)
            {
                return value.endsWith(match);
            }
        // SPLIT | COMPARE__


        
        // JSON_
            export function json_encode(value)
            {
                return JSON.stringify(value);                
            }
            export function json_decode(json)
            {
                return JSON.parse(json);
            }
        // JSON_
            
        // SPLIT
            export function split(value, match)
            {
                try {
                    if(value && value.split(match)[1] != null){
                        return true;
                    }
                } catch (error) { }
                return false;
            }
        // SPLIT

        // REQUEST OBJ / PAGG
            export function request_obj(request, $this)
            {
                for(let key in request?.OBJ){
                    let $array = request.OBJ[key];

                    if($array?.data){
                        $this.OBJ[key] = $array.data;

                        // PAGG
                            $array.data = [];

                            // LINKS
                                let $next;
                                let value_1;
                                let $links = [];
                                for(let key in $array.links){
                                    let value = $array.links[key];

                                    $next = MOBILE() ? 0 : 1;

                                    if(value.label == `&laquo; Anterior`){
                                        value.label = `<`;
                                        value.url = $array?.links?.[1]?.url ? $array.links[1].url : ``;
                                        $next = 1;
                                    }
                                    if(value.label == `Próxima &raquo;`){
                                        value.label = `>`;
                                        value.url = $array?.links?.[key-1]?.url ? $array.links[key-1].url : ``;
                                        $next = 1;
                                    }
                                    if(value.label == `...` && !MOBILE()){
                                        $next = 1;
                                    }

                                    // MOBILE
                                        if(MOBILE()){
                                            if(value.active == true){
                                                // PREV
                                                    value_1 = $array.links[parseInt(key)-3];
                                                    if(value_1 && value_1.label != `<` && value_1.label != `...` && value_1.label != `>` && value_1.label != `&laquo; Anterior` && value_1.label != `Próxima &raquo;`){
                                                        value_1.url = replace(DIR_API(), ``, value_1.url);
                                                        value_1.label = '...';
                                                        $links.push(value_1);
                                                    }
                                                    value_1 = $array.links[parseInt(key)-2];
                                                    if(value_1 && value_1.label != `<` && value_1.label != `...` && value_1.label != `>` && value_1.label != `&laquo; Anterior` && value_1.label != `Próxima &raquo;`){
                                                        value_1.url = replace(DIR_API(), ``, value_1.url);
                                                        $links.push(value_1);    
                                                    }
                                                    value_1 = $array.links[parseInt(key)-1];
                                                    if(value_1 && value_1.label != `<` && value_1.label != `...` && value_1.label != `>` && value_1.label != `&laquo; Anterior` && value_1.label != `Próxima &raquo;`){
                                                        value_1.url = replace(DIR_API(), ``, value_1.url);
                                                        $links.push(value_1);    
                                                    }
                                                // PREV

                                                // CURRENT
                                                    value.url = replace(DIR_API(), ``, value.url);
                                                    $links.push(value);
                                                // CURRENT
        
                                                // NEXT
                                                    value_1 = $array.links[parseInt(key)+1];
                                                    if(value_1 && value_1.label != `<` && value_1.label != `...` && value_1.label != `>` && value_1.label != `&laquo; Anterior` && value_1.label != `Próxima &raquo;`){
                                                        value_1.url = replace(DIR_API(), ``, value_1.url);
                                                        $links.push(value_1);    
                                                    }
                                                    value_1 = $array.links[parseInt(key)+2];
                                                    if(value_1 && value_1.label != `<` && value_1.label != `...` && value_1.label != `>` && value_1.label != `&laquo; Anterior` && value_1.label != `Próxima &raquo;`){
                                                        value_1.url = replace(DIR_API(), ``, value_1.url);
                                                        $links.push(value_1);    
                                                    }
                                                    value_1 = $array.links[parseInt(key)+3];
                                                    if(value_1 && value_1.label != `<` && value_1.label != `...` && value_1.label != `>` && value_1.label != `&laquo; Anterior` && value_1.label != `Próxima &raquo;`){
                                                        value_1.url = replace(DIR_API(), ``, value_1.url);
                                                        value_1.label = '...';
                                                        $links.push(value_1);    
                                                    }
                                                // NEXT
                                            }
                                        }
                                    // MOBILE

                                    if($next){
                                        value.url = replace(DIR_API(), ``, value.url);
                                        $links.push(value);
                                    }
                                }
                            // LINKS

                            $this.OBJ.pagg[key] = $links;
                            $this.OBJ.pagg[`${key}_all`] = $array;
                        // PAGG

                    } else {
                        $this.OBJ[key] = $array;
                    }
                }   
            }
        // REQUEST OBJ / PAGG
        
        // STRIP TAGS
            export function strip_tags(input, allowed)
            {
                allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('')
                let tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
                let commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi
                return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1){
                    return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''
                })
            }
        // STRIP TAGS

        // REPLACE
            export function replace($de, $para, $txt)
            {
                let $return = ``;
                if($txt){
                    $return = $txt;
                    try {
                        if($txt.indexOf($de) >= 0){
                            let $pos = $txt.indexOf($de);
                            while ($pos > -1){
                                $return = $return.replace($de, $para);
                                $pos = $return.indexOf($de);
                            }
                        }
                    } catch(e) {}
                }
                return $return;
            }
        // REPLACE

        // ADDRESS
            export function address_1(value)
            {
                let $return = ``;
                $return += value?.address;
                $return += value?.number ? `, ${value.number} ` : ``;
                $return += value?.complement;
                return $return;
            }
            export function address_2(value)
            {
                let $return = ``;
                $return += value.neighborhood ? `${value.neighborhood} - ` : ``;
                $return += value?.state;
                $return += value?.city ? `/${value.city}` : ``;
                return $return;
            }
            export function address_3(value)
            {
                return value?.zipcode;
            }
        // ADDRESS

        // NAME
            export function name__(name, $tipo=0) // 0-> So nome; 1->So Sobrenome; 2->x qtd de nome
            {
                if(name == null){
                    return ``;
                }

                let ex = name.split(' ');

                // NOME
                    if($tipo == 0){
                        return ex[0];
                    }
                // NOME

                // SOBRENOME
                    if($tipo == 1){
                        return ex[1]!=null ? ex[1] : ``;
                    }
                // SOBRENOME

                // QTD
                    if($tipo >= 2){
                        let $return = ``;
                        for (let i = 0; i < $tipo; i++) {
                            $return += ex[i] ? `${ex[i]} ` : ``;

                            // SO NOME FOR MENOR QUE X VAR
                                if(ex[i] != null && ex[i].length < 4){
                                    i++;
                                    $return += (ex[i]!=null && ex[i]) ? `${ex[i]} ` : ``;
                                }
                            // SO NOME FOR MENOR QUE X VAR
                        }
                        $return = $return.trim();
                        $return = replace('-', '', $return);
                        $return = replace('_', '', $return);
                        return $return;
                    }
                // QTD
            }
        // NAME

        // NAME_INI
            export function name_ini(name)
            {
                let $return = ``;

                if(name != null && name){
                    let ex = name.split(' ');

                    $return = ex[0][0];
                    if(ex[1] != null && ex[1][0] != null){
                        $return += ex[1][0];
                    }
                }

                $return = replace('-', '', $return);
                $return = replace('_', '', $return);
                return $return;
            }
        // NAME_INI

        // MINUSCULO
            export function minusculo(str)
            {
                return str.toLowerCase();
            }
        // MINUSCULO

        // TOP
            export function top()
            {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                  });
            }
        // TOP

        // UCFIRST
            export function ucfirst(str)
            {
                if (!str) return str;
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
        // UCFIRST
       
        // IMPLODE
            export function implode(separator, array)
            {
                if(typeof array === "object"){
                    let array_temp = array
                    array = [];
                    for(let key in array_temp){
                        array.push(key);
                    }
                }
                return array.join(separator);
            }
        // IMPLODE

        // LIMIT
            export function limit(text, limit, ellipsis='...', tirm=1)
            {
                if(text != null && text.length > limit) {
                    text = text.substr(0, limit);
                    if(tirm){
                        text = text.trim();
                    }
                    text += ellipsis;
                }

                return text;
            }
        // LIMIT

        // YEARS__
            export function years__(extra)
            {
                let $ex = extra.split('->');
                let currentYear = new Date().getFullYear();
                let year_final = parseInt($ex[2]!=undefined ? $ex[2] : 1950);
                let $return = [];
                for (let year = currentYear; year >= year_final; year--) {
                    $return.push({'id': year, 'name': year});
                }
                return $return;
            }
        // YEARS__

        // OPTIONS__
            export function options__(extra)
            {
                let $return = [];

                extra = replace('-->', '', extra);
                extra = extra.split('; ');

                for(let key in extra){
                    let value = extra[key];

                    if(value != null && value.match(`: `)){
                        let ex = value.split(': ');

                        if(ex[1] != null){
                            $return.push({'id': ex[0], 'name': ex[1]});
                        }
                    }
                }

                return $return;
            }
        // OPTIONS__

        // TITLE
            export function titulo(name, o, s=``)
            {
                let $return = {};

                $return.o = o ? o : ``;
                $return.os = o ? `${o}s` : ``;

                $return.m = name ? name : ``;
                $return.ms = name ? `${name}s` : ``;
                $return.mo = (name && o) ? `${o} ${name}` : ``;
                $return.mos = (name && o) ? `${o}s ${name}s` : ``;

                $return.u = name ? first_letter_uppercase(name): ``;
                $return.us = name ? first_letter_uppercase(`${name}s`): ``;
                $return.uo = (name && o) ? first_letter_uppercase(`${o} ${name}`): ``;
                $return.uos = (name && o) ? first_letter_uppercase(`${o}s ${name}s`): ``;

                //{ m: 'cliente', ms: 'clientes', mo: 'o cliente', mos: 'os clientes', u: 'Cliente', us: 'Clientes', uo: 'O cliente', uos: 'Os clientes' }

                return $return;
            }
        // TITLE

        // FIRST_LETTER_UPPERCASE
            export function first_letter_uppercase(string) 
            {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        // FIRST_LETTER_UPPERCASE

        // RAND
            export function rand__()
            {
                return Math.floor(Math.random() * 100000) + 1;
            }
        // RAND

        // HTTP
            export function http(value)
            {
                if(!value){
                    return ``;
                }
				return (!/http/.test(value)) ? `http://${value}` : value;
            }
        // HTTP

        // OPEN__
            export function open__(url, target=`_system`, options=`location=yes`) // _self, _blank, _system
            {
                if(APP() == 2){
                    cordova.InAppBrowser.open(url, target, options);
                } else {
                    window.open(url, `_blank`);
                }
            }
        // OPEN__

        // OPEN
            export function open(pg, ROUTER)
            {
                const queryParams = {};
                queryParams.v = new Date().getTime();

                ROUTER.push({ path: pg, query: queryParams });
            }
        // OPEN

        // COPY__
            export function copy__($class, $text='Link Copiado com Sucesso!')
            {
                document.querySelector($class).select();
                let successful = document.execCommand('copy');
                alerts(1, $text);
            }
        // COPY__

        // NO_ACECENT
            export function no_accent($strToReplace)
            {
                let $str_acento = "áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ";
                let $str_no_accent = "aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC";
                let $return = "";
                for (let i = 0; i < $strToReplace.length; i++){
                    if ($str_acento.indexOf($strToReplace.charAt(i)) != -1){
                        $return += $str_no_accent.substr($str_acento.search($strToReplace.substr(i, 1)), 1);
                    } else {
                        $return += $strToReplace.substr(i, 1);
                    }
                }
                return $return;
            }
        // NO_ACECENT

        // IS_E
            export function is_e($e, $all=0)
            {
                let $return = ``;

                if($e.classList != null){
                    $return = $e;
                } else if($all){
                    $return = document.querySelectorAll($e);
                    if(!$return[0]){
                        $return = '';
                    }
                } else {
                    $return = document.querySelector($e);
                }

                return $return;
            }
        // IS_E

        // BASE64
            export function base64_encode($string)
            {
                return btoa($string);
            }
            export function base64_decode($string)
            {
                return atob($string);
            }
        // BASE64

        // MOBILE
            export function MOBILE()
            {
                const userAgent = navigator.userAgent.toLowerCase();
                if (userAgent.includes('mobi')) {
                    return true;
                } else {
                    return false;
                }
            }
        // MOBILE
    // USEFUL







    // ARRAY
        // MONTH
            export function month($month)
            {
                let $return = ['', 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
                return $return[$month];
            }
            export function month_ab($month)
            {
                let $return = ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
                return $return[$month];
            }
            export function month_select($month=0)
            {
                let $return = [
                            {'id': 1, 'name': 'Janeiro', 'selected': ($month==1)}, 
                            {'id': 2, 'name': 'Fevereiro', 'selected': ($month==2)}, 
                            {'id': 3, 'name': 'Março', 'selected': ($month==3)}, 
                            {'id': 4, 'name': 'Abril', 'selected': ($month==4)}, 
                            {'id': 5, 'name': 'Maio', 'selected': ($month==5)}, 
                            {'id': 6, 'name': 'Junho', 'selected': ($month==6)}, 
                            {'id': 7, 'name': 'Julho', 'selected': ($month==7)}, 
                            {'id': 8, 'name': 'Agosto', 'selected': ($month==8)}, 
                            {'id': 9, 'name': 'Setembro', 'selected': ($month==9)}, 
                            {'id': 10, 'name': 'Outubro', 'selected': ($month==10)}, 
                            {'id': 11, 'name': 'Novembro', 'selected': ($month==11)}, 
                            {'id': 12, 'name': 'Dezembro', 'selected': ($month==12)}
                        ];
                return $return;
            }
        // MONTH

        // STATE
            export function state($state='')
            {
                let $return = [
                            {'id': 'AC', 'name': 'Acre', 'selected': ($state=='AC')}, 
                            {'id': 'AL', 'name': 'Alagoas', 'selected': ($state=='AL')}, 
                            {'id': 'AM', 'name': 'Amazonas', 'selected': ($state=='AM')}, 
                            {'id': 'AP', 'name': 'Amapá', 'selected': ($state=='AP')}, 
                            {'id': 'BA', 'name': 'Bahia', 'selected': ($state=='BA')}, 
                            {'id': 'CE', 'name': 'Ceará', 'selected': ($state=='CE')}, 
                            {'id': 'DF', 'name': 'Distrito Federal', 'selected': ($state=='DF')}, 
                            {'id': 'ES', 'name': 'Espírito Santo', 'selected': ($state=='ES')}, 
                            {'id': 'GO', 'name': 'Goiás', 'selected': ($state=='GO')}, 
                            {'id': 'MA', 'name': 'Maranhão', 'selected': ($state=='MA')}, 
                            {'id': 'MG', 'name': 'Minas Gerais', 'selected': ($state=='MG')}, 
                            {'id': 'MS', 'name': 'Mato Grosso do Sul', 'selected': ($state=='MS')}, 
                            {'id': 'MT', 'name': 'Mato Grosso', 'selected': ($state=='MT')}, 
                            {'id': 'PA', 'name': 'Pará', 'selected': ($state=='PA')}, 
                            {'id': 'PB', 'name': 'Paraíba', 'selected': ($state=='PB')}, 
                            {'id': 'PE', 'name': 'Pernambuco', 'selected': ($state=='PE')}, 
                            {'id': 'PI', 'name': 'Piauí', 'selected': ($state=='PI')}, 
                            {'id': 'PR', 'name': 'Paraná', 'selected': ($state=='PR')}, 
                            {'id': 'RJ', 'name': 'Rio de Janeiro', 'selected': ($state=='RJ')}, 
                            {'id': 'RN', 'name': 'Rio Grande do Norte', 'selected': ($state=='RN')}, 
                            {'id': 'RO', 'name': 'Rondônia', 'selected': ($state=='RO')}, 
                            {'id': 'RR', 'name': 'Roraima', 'selected': ($state=='RR')}, 
                            {'id': 'RS', 'name': 'Rio Grande do Sul', 'selected': ($state=='RS')}, 
                            {'id': 'SC', 'name': 'Santa Catarina', 'selected': ($state=='SC')}, 
                            {'id': 'SE', 'name': 'Sergipe', 'selected': ($state=='SE')}, 
                            {'id': 'SP', 'name': 'São Paulo', 'selected': ($state=='SP')}, 
                            {'id': 'TO', 'name': 'Tocantins', 'selected': ($state=='TO')}, 
                        ];
                return $return;
            }
        // STATE
    // ARRAY







    // OTHERS
        // CITY
            export function city__(FORM, OBJ, zerar_cidade=1, $load=0, $v='v')
            {
                if(FORM[$v].state != null){
                    if($_GLOBAL['city__'] == null){
                        $_GLOBAL['city__'] = 1;
                        setTimeout(() => { $_GLOBAL['city__'] = null }, 2000);

                        api(`/city`, { state: FORM[$v].state }, (request) => {
                            OBJ.city = request.OBJ.city;
                            if(zerar_cidade){
                                FORM[$v].city = "";
                            }

                            if($_GLOBAL['city__value'] != null && $_GLOBAL['city__value']){
                                FORM[$v].city = $_GLOBAL['city__value'];
                                $_GLOBAL['city__value'] = ``;
                            }

                            // SELECT2
                                select2_reset(`#select_city`);
                            // SELECT2
                        }, $load)
                    }
                }
            }
        // CITY

        // ZIP_CODE
            export function zip_code__(FORM, OBJ, $v='v')
            {
                if(FORM[$v].zipcode.length >= 10){
                    if($_GLOBAL['zip_code__'] == null){
                        $_GLOBAL['zip_code__'] = 1;
                        setTimeout(() => { $_GLOBAL['zip_code__'] = null }, 2000);

                        api(`/zipcode`, { zipcode: FORM[$v].zipcode }, (request) => {
                            FORM[$v].address = request.address;
                            FORM[$v].neighborhood = request.neighborhood;

                            if(FORM[$v].state_txt != null){
                                FORM[$v].state_txt = request.state ? request.state : ``;
                                FORM[$v].city_txt = request.city ? request.city : ``;

                            } else {
                                $_GLOBAL['city__'] = 1;
                                FORM[$v].state = request.state ? request.state : ``;
                                $_GLOBAL['city__value'] = request.city ? request.city : ``;
                                setTimeout(() => {
                                    $_GLOBAL['city__'] = null;
                                    city__(FORM, OBJ, 1, 0, $v);
                                }, .5);

                                if(document.activeElement?.getAttribute(`name`) != undefined){
                                    if(document.activeElement?.getAttribute(`name`).match(`zipcode`)){
                                        let inputs = document.querySelectorAll('input');
                                        let currentIndex = Array.prototype.indexOf.call(inputs, document.activeElement);
                                        if (currentIndex !== -1 && currentIndex < inputs.length - 1) {
                                            inputs[currentIndex + 1].focus();
                                        }
                                    }
                                }
                            }
                        })    
                    }
                }
            }
        // ZIP_CODE
    // OTHERS






    // VERIFICATIONS
        // IS_NUMBER
            export function is_number(value)
            {
                return !isNaN(parseFloat(value)) && isFinite(value);
            }
        // IS_NUMBER
    // VERIFICATIONS







    // CREATE_JS
        export function create_js(url)
        {
            var script = document.createElement('script');
            script.src = url;
            script.type = 'text/javascript';
            script.onload = function() {
            };
            script.onerror = function() {
                console.error('Erro ao carregar o script ' + url);
            };
            document.head.appendChild(script);
        }
    // CREATE_JS







    // CODIFICATION
        export function crip(value)
        {
            const substituicoes = {
                '0': 'ENA;;QV',
                '1': 'BA-_VEC',
                '2': 'SD;;XAY',
                '3': 'TO||LUF',
                '4': 'LPD_,WU',
                '5': 'PFA-;YT',
                '6': 'GIV.;ZBX',
                '7': 'MED-;HRF',
                '8': 'RDB;$JY',
                '9': 'TCK#@XFG',
                '/': 'NIP;#TIU',
                ' ': 'YSU@;IR'
            };
            for (const [chave, valor] of Object.entries(substituicoes)) {
                value = value.split(chave).join(valor);
            }
            value = btoa(value);
            return value;
        }
        export function crip_(value)
        {
            value = atob(value);
            const substituicoes = {
                'ENA;;QV': '0',
                'BA-_VEC': '1',
                'SD;;XAY': '2',
                'TO||LUF': '3',
                'LPD_,WU': '4',
                'PFA-;YT': '5',
                'GIV.;ZBX': '6',
                'MED-;HRF': '7',
                'RDB;$JY': '8',
                'TCK#@XFG': '9',
                'NIP;#TIU': '/',
                'YSU@;IR': ' '
            };
            for (const [chave, valor] of Object.entries(substituicoes)) {
                value = value.split(chave).join(valor);
            }
            return value;
        }
        export function cod(type, txt)
        {
            let $return = txt;
    
            if(type == `asc`){
                $return = replace(`'`, `&#39;`, $return);
                $return = replace(`"`, `&#34;`, $return);
                $return = replace(`´`, `&#180;`, $return);
                $return = replace('`', `&#96;`, $return);
                $return = replace(`?`, `&#63;`, $return);
                $return = replace(`!`, `&#33;`, $return);
                $return = replace(`=`, `&#61;`, $return);
                $return = replace(`<`, `&#60;`, $return);
                $return = replace(`>`, `&#62;`, $return);
            }

            return $return;
        }
    // CODIFICATION







    // APP
        // HREF
            export function href_APP()
            {
                if(APP()){
                    setTimeout(() => {
                        document.querySelectorAll('a[href], a[href__]').forEach($item => {
                            let $link = $item.getAttribute('href');
                            if(!$link) $link = $item.getAttribute('href__');

                            // BLANK
                                if($item.getAttribute('target') == '_blank'){
                                    $item.addEventListener("click", (e) => {
                                        if($link != '/'){
                                            $link = replace(DIR(), '', $link);
                                        }

                                        e.preventDefault();
                                        if($link && $link != null && $link != undefined && $link != 'null' && $link != 'undefined'){
                                            open__($link);
                                        }
                                    });
                                }
                            // BLANK

                            // ROUTER
                                else {
                                    $item.addEventListener("click", (e) => {
                                        if($link != '/'){
                                            $link = replace(DIR(), '', $link);
                                        }

                                        e.preventDefault();
                                        if($link && $link != null && $link != undefined && $link != 'null' && $link != 'undefined'){
                                            router.push($link);
                                        }
                                    });
                                }
                            // ROUTER
                        });
                    }, .5);
                }
            }
        // HREF
    // APP
